import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from 'src/app/_core/_services/api.service';

@Injectable({
  providedIn: 'root'
})
export class NetworkProductsService {
  constructor(private api: ApiService) {}

  getNetworkPortalProducts(queryParams?: any) {
    if (queryParams) {
      queryParams = {
        ...queryParams
      };
    } else {
      queryParams = {
        limit: 100,
        offset: 0,
        q: '',
        filter: []
      };
    }
    return this.api
      .getAPI('network-portal/billing/products', queryParams)
      .pipe(map((res) => res.body.results));
  }
}
